import { useMessageSource } from "react-message-source";
import * as Yup from "yup";

export default function usePasswordResetUsernameFormValidationScheme() {
  const { getMessage } = useMessageSource();

  const validateEmail = Yup.string()
    .email(getMessage("Validation.message-email"))
    .required(getMessage("Validation.message-required"));

  return Yup.object().shape({
    email: validateEmail,
  });
}
